import httpClient from '~/http';
import { UserRoleFormValues, UserRoleItem } from '../types';

const getUserRole = (id: string) => {
  return httpClient
    .get<{ userRestaurantRoles: UserRoleItem[] }>(
      '/api/v2/user-restaurant-roles',
      {
        params: {
          userRestaurantRoleId: id,
        },
      }
    )
    .then(({ userRestaurantRoles }) => userRestaurantRoles[0]);
};

const getManyUserRole = () => {
  return httpClient
    .get<{ userRestaurantRoles: UserRoleItem[] }>(
      '/api/v2/user-restaurant-roles'
    )
    .then(({ userRestaurantRoles }) => userRestaurantRoles);
};

const createUserRole = (values: UserRoleFormValues) => {
  return httpClient.post('/api/v2/user-restaurant-roles', values);
};

const updateUserRole = (id: string, values: UserRoleFormValues) => {
  return httpClient.put(`/api/v2/user-restaurant-roles/${id}`, values);
};

export default {
  getUserRole,
  getManyUserRole,
  createUserRole,
  updateUserRole,
};
